/**
 * The org's service registry, keyed by identity: which project each
 * onboarding agent was registered for (#219). Read from the org module's
 * public `registered_service` table on its own subscription (see
 * SpacetimeProvider). A registry that never arrives leaves the map empty,
 * which only turns the portal's extra check off — the module's own
 * one-agent-per-project guard still applies.
 */
import { useMemo } from 'react';
import { useTable } from 'spacetimedb/react';
import { tables as orgTables } from '@sdk/org';
import { normalizeHex, type RegisteredAgentInfo } from '@/lib/agentBinding';

export function useRegisteredAgents(): ReadonlyMap<string, RegisteredAgentInfo> {
  const [rows] = useTable('org', orgTables.registeredService);
  return useMemo(() => {
    const map = new Map<string, RegisteredAgentInfo>();
    for (const r of rows) {
      if (!r.identityHex) continue;
      map.set(normalizeHex(r.identityHex), { orgProjectId: r.projectId, serviceName: r.name });
    }
    return map;
  }, [rows]);
}
